import React from 'react'

// Style sheet
import '../scss/mainPageContent.scss';

// Page components
import TopNavbar from "../../components/pagecomponents/ts/topNavbar";
import Footer from "../../components/pagecomponents/ts/Footer";
import PageBanner from '../../components/pagecomponents/ts/pageBanner';
import RadarWeatherMap from '../../components/pagecomponents/ts/radarWeatherMap';
import WeatherForecast from '../../components/weatherhkocomponents/ts/weatherForecast';
import WeatherOutlook from '../../components/weatherhkocomponents/ts/weatherOutlook';
import WeatherWarning from '../../components/weatherhkocomponents/ts/weatherWarning';
import WeatherAlert from '../../components/weatherhkocomponents/ts/weatherAlert';
import FeltTremorAlert from '../../components/weatherhkocomponents/ts/feltTremorAlert';
// END

function MainPageContent() {

  return (
    <div>
        {/* Navbar */}
        <div>
          <TopNavbar />
        </div>

        <div>
          <PageBanner 
            title={"專業氣象"} 
            description={"為你帶來最優質的氣象服務"} 
            icon={"FaCloudSunRain"} 
            id={"mainPageBanner"}
          />
        </div>

        <div className='' id=''>
          <FeltTremorAlert />
        </div>
        
        <div className='' id=''>
          <WeatherAlert />
        </div>

        <div className='' id=''>
          <WeatherWarning />
        </div>

        <div className='' id=''>
          <RadarWeatherMap />
        </div>

        <div className='' id=''>
          <WeatherForecast />
        </div>

        <div className='' id=''>
          <WeatherOutlook />
        </div>

        <div>
          <Footer />
        </div>

    </div>
  )

}

export default MainPageContent;